import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from "react-router-dom";
import GoBackBtn from "../../GoBackBtn";
import { wstepy } from '../../../functions/motions';
import { sortByNum, sortByTxt } from "../../../functions/utilities";
import { dataFormat } from "../../../functions/dataFormat";
import { ikona } from "../../../functions/ikony";
import GrupyInstrukcja from "./GrupyInstrukcja";
import { adresPro2 } from "../../../functions/ulice";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleInfo } from '@fortawesome/free-solid-svg-icons';
import { fetchUdzialyKonta, fetchGrupy, fetchUlice, fetchLokale, fetchWspolnota, fetchMieszkancy } from "../../../Redux/Actions";

const Grupy = () => {

    const queryParams = new URLSearchParams(window.location.search)
    const idw = queryParams.get("id");
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const udzialyKonta = useSelector( state => state?.udzialyKonta?.data);
    const grupy = useSelector( state => state?.grupy?.data);
    const ulice = useSelector( state => state?.ulice?.data);
    const lokale = useSelector( state => state?.lokale?.data);
    const wspolnotaArr = useSelector( state => state?.wspolnoty?.data);
    const mieszkancy = useSelector( state => state?.mieszkancy?.data);

    const [wspolnota, setWspolnota] = useState([]);
    const [duble, setDuble] = useState([]);
    const [showHelp, setShowHelp] = useState(false);

    useEffect( () => setWspolnota( wspolnotaArr?.find( w => w?.id == idw)), [idw, wspolnotaArr]);
    
    useEffect( ()=> {
        dispatch(fetchWspolnota(idw)); 
        dispatch(fetchMieszkancy(idw)); 
        dispatch(fetchLokale(idw)); 
        dispatch(fetchUlice(idw)); 
        dispatch(fetchGrupy(idw)); 
        dispatch(fetchUdzialyKonta(idw));
    },[dispatch]);
    
    const znajdzDuplikaty = (grupy) => {
        const map = new Map();
        const duplikaty = [];
      
        grupy?.forEach((obiekt) => {
          const klucz = `${obiekt?.id_user}-${obiekt?.grupa_numer}-${obiekt?.data_od}`;
      
          if (map.has(klucz)) {
            if (map.get(klucz) === 1) {
              // Dodaj pierwszy znaleziony duplikat
              duplikaty.push(obiekt);
            }
            // Zwiększ licznik wystąpień
            map.set(klucz, map.get(klucz) + 1);
          } else {
            // Dodaj unikalny klucz do mapy
            map.set(klucz, 1);
          }
        });
      
        // Dodaj kolejne wystąpienia do tablicy duplikatów
        grupy?.forEach((obiekt) => {
          const klucz = `${obiekt?.id_user}-${obiekt?.grupa_numer}-${obiekt?.data_od}`;
          if (map.get(klucz) > 1) {
            duplikaty.push(obiekt);
          }
        });
      
        return duplikaty;
    };

    useEffect( () =>  setDuble(znajdzDuplikaty(udzialyKonta) ), [udzialyKonta]);
    
    const lista = sortByTxt(mieszkancy,"imie_nazwisko")?.map( (mieszkaniec, i) =>{

        const udzialy = sortByNum(udzialyKonta?.filter( u => u?.id_user == mieszkaniec.id_user),"grupa_numer");

        const udzialyLista = udzialy?.map( (udzial, j) => {

            const grupy_m = grupy?.filter( g => g?.id_user == mieszkaniec?.id_user && g?.grupa_numer == udzial?.grupa_numer);
            const czyDubel = duble?.find( d => d?.id == udzial.id) ? true : false;
            const czyOstatni = j < udzialy?.length - 1 ? true : false;
            let styl = "";

            if (czyDubel && czyOstatni)
                styl = "red udzialyRow border pointer "
            else if (czyDubel && !czyOstatni)
                styl = "red udzialyRow pointer "
            else if (!czyDubel && czyOstatni)
                styl = "udzialyRow border pointer "
            else 
                styl = "udzialyRow pointer "

            const lokaleGrupy = grupy_m?.map( (grupa, i) => {

                const rodzaj_lokalu = lokale?.find( l => l.id == grupa.id_lokal)?.rodzaj;
                const lokalAdres = adresPro2(udzial, lokale, ulice, [grupa], rodzaj_lokalu);
                
                return (
                    <div 
                        className="grupaRow"
                        key={i}
                    >
                        <div className="adres">
                            {ikona(rodzaj_lokalu)}{lokalAdres} 
                        </div>
                        <div className="data">
                            {`data grupy od: ${dataFormat(grupa?.data_od)}`}
                        </div>
                    </div>
                )
            })
            const link_user = mieszkaniec?.id_user;
            const link_grupa = udzial?.grupa_numer;
            const handleLink = () => navigate(`/mieszkancy?idw=${idw}`, { state: { link_user, link_grupa } });

            return (
                <div 
                    key={j}
                    className={ styl } 
                    onClick={handleLink}
                >
                    <div key={j} className="udzialRow">
                        <div style={{fontWeight: "500"}}>
                            {`grupa numer: ${udzial?.grupa_numer} (id: ${udzial?.id})`}
                        </div>
                        <div className="data">
                            {`data lokalu od: ${dataFormat(udzial?.data_od)}`}
                        </div>
                        <div className="data">
                            {`liczba mieszkańców: ${udzial?.liczba_domownikow}`}
                        </div>
                    </div>
                    <div className="grupyRow">
                        { lokaleGrupy }
                    </div>
                </div>
            )
        })


        return (
            <li 
                key={i}
            >
                <div className="mieszkaniec">
                    {`${mieszkaniec?.imie_nazwisko} (id ${mieszkaniec?.id_user})`}
                </div>
                <div className="udzialyGrupy">
                    {udzialyLista}
                </div>
            </li>
        )
    });

    const handleHelp = () => setShowHelp( prevState => !prevState);

    return (
        <div 
            className="content grupyLista"
            variants={wstepy}
            initial="initial"
            animate="animate"
        >
            <h1 className="nazwa">
                Grupy we wspólnocie
            </h1>
            <h3>
                { `${wspolnota?.name} (id: ${wspolnota.id})` }
            </h3>
            <div className="buttonsBar">
                <div className="buttonsZbiorowka">
                    <GoBackBtn />
                </div>
                <div>
                    <FontAwesomeIcon 
                        icon={faCircleInfo} 
                        size="2xl"
                        className="pointer"
                        onClick={handleHelp}
                    />
                </div>
            </div>
            { showHelp && <GrupyInstrukcja setShowHelp={setShowHelp} /> }
            <div className="lista">
                <ul>
                    {lista}
                </ul>
            </div>
        </div>
    )
}

export default Grupy;